module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (show) { 
__p+='\n	<div class="global-notification-popup-overlay">\n		<div class="global-notification-popup-inner js-notification" id="global_notification">\n			'+
((__t=( text ))==null?'':__t)+
'\n		</div>\n		<a class="icon-close js-close">\n			<i class="ion-android-close"></i>\n		</a>\n	</div>\n';
 } 
__p+='';
}
return __p;
};
